module.exports = require("ramda/src/flatten");